import React, { createContext, useEffect, useState } from 'react';

import { FeatureFlags } from '@/app/config/featureFlags';

type FeatureFlagsContextType = {
  flags: FeatureFlags;
  isLoading: boolean;
};

export const FeatureFlagsContext = createContext<
  FeatureFlagsContextType | undefined
>(undefined);

type FeatureFlagsProviderProps = {
  children: React.ReactNode;
};

export const FeatureFlagsProvider: React.FC<FeatureFlagsProviderProps> = ({
  children,
}) => {
  const [flags, setFlags] = useState<FeatureFlags>({
    enableNewUI: true, // Default fallback for local dev
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Read feature flags from window object injected by server
    const serverFlags = (window as { __ITOPFIVE_FLAGS__?: FeatureFlags })
      .__ITOPFIVE_FLAGS__;

    if (serverFlags) {
      setFlags(prevFlags => ({
        ...prevFlags,
        ...serverFlags,
      }));
    }

    setIsLoading(false);
  }, []);

  const value: FeatureFlagsContextType = {
    flags,
    isLoading,
  };

  return (
    <FeatureFlagsContext.Provider value={value}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};
